import { lazy, Suspense, useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Nav } from './components/Nav'
import { ConnectGate } from './components/ConnectGate'
import { useAuth } from './store/auth'
import { useBsky } from './store/bsky'
import { useBranding } from './store/branding'
import { Home } from './pages/Home'
import { GameMode } from './pages/GameMode'
import { TiledMode } from './pages/TiledMode'
import { GalleryMode } from './pages/GalleryMode'
import { MemoryMode } from './pages/MemoryMode'
import { ScoreBoard } from './pages/ScoreBoard'
import { Login } from './pages/Login'
import { Profile } from './pages/Profile'

// Admin is split out of the main bundle — load times matter, and only the
// admin ever loads it.
const Admin = lazy(() => import('./pages/Admin').then((m) => ({ default: m.Admin })))

export function App() {
  const initAuth = useAuth((s) => s.init)
  const loadBranding = useBranding((s) => s.load)
  const isAdmin = useAuth((s) => s.isAdmin)

  useEffect(() => {
    useBsky.getState().load()
    void initAuth()
    void loadBranding()
  }, [initAuth, loadBranding])

  return (
    <div className="min-h-full">
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/play" element={<ConnectGate><GameMode /></ConnectGate>} />
        <Route path="/tiles" element={<ConnectGate><TiledMode /></ConnectGate>} />
        <Route path="/gallery" element={<ConnectGate><GalleryMode /></ConnectGate>} />
        <Route path="/memory" element={<ConnectGate><MemoryMode /></ConnectGate>} />
        <Route path="/scoreboard" element={<ScoreBoard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/admin"
          element={
            isAdmin ? (
              <Suspense fallback={<div className="p-8 text-center font-comic text-2xl text-pow">LOADING ADMIN…</div>}>
                <Admin />
              </Suspense>
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  )
}
